<template>
  <div>
    <a-card
      title="积分交易查询"
      size="small"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <a-form
        layout="inline"
        labelAlign="right"
        :labelCol="labelCol"
        ref="resetForm"
        :model="form"
      >
        <a-form-item label="积分平台订单号" name="supplierOrderId">
          <a-input v-model:value="form.supplierOrderId"></a-input>
        </a-form-item>
        <a-form-item label="积分名称" name="carrier">
          <a-select v-model:value="form.carrier" style="width:195px">
            <a-select-option
              v-for="(item, index) in scoreNameList"
              :value="item.value"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="积分平台会员ID" name="memberId">
          <a-input v-model:value="form.memberId"> </a-input>
        </a-form-item>
        <a-form-item label="交易时间" name="date">
          <a-range-picker
            style="width: 195px"
            valueFormat="YYYY-MM-DD"
            format="YYYY-MM-DD"
            v-model:value="form.date"
          ></a-range-picker>
        </a-form-item>
        <a-form-item label="订单号" name="orderId">
          <a-input style="width: 195px" v-model:value="form.orderId"></a-input>
        </a-form-item>
        <a-form-item label="渠道名称" name="distributorId">
          <a-select v-model:value="form.distributorId" style="width:195px">
            <a-select-option
              v-for="(item, index) in channelNameList"
              :value="item.value"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="渠道会员ID" name="distributorAccount">
          <a-input v-model:value="form.distributorAccount"> </a-input>
        </a-form-item>
        <a-form-item label="订单状态" name="state">
          <a-select v-model:value="form.state" style="width:195px">
            <a-select-option
              v-for="(item, index) in orderTypeList"
              :key="index"
              :value="item.value"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
      <div style="display:flex;justify-content:center;">
        <a-form-item>
          <a-button class="mr" type="primary" @click="query"> 查询 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button class="mr" @click="reset()">重置</a-button>
        </a-form-item>
        <a-form-item>
          <a-button class="mr" @click="openModal()">添加</a-button>
        </a-form-item>
        <a-form-item>
          <a-button class="mr" type="primary" @click="exports"> 导出 </a-button>
        </a-form-item>
        <a-form-item style="width:350px">
          <a-form-item>
            <a-button @click="createBill">导入</a-button>
          </a-form-item>
        </a-form-item>
      </div>
    </a-card>
    <a-table
      bordered
      :dataSource="list"
      :pagination="false"
      :columns="columns"
      style="word-break: break-all"
      :loading="loading"
      :rowKey="
        (record, index) => {
          return index;
        }
      "
    >
      <template #carrier="{text,record}">
        {{
          record.carrier === "CA"
            ? "国航"
            : record.carrier === "MU"
            ? "东航"
            : ""
        }}
      </template>
      <template #payAmount="{text,record}">
        {{
          record.distributorId == 1041 && record.orderType === 1
            ? record.payAmount / 100
            : record.payAmount == 0
            ? (record.payAmount = "")
            : record.payAmount
        }}
      </template>
      <template #orderState="{text,record}">
        {{ compareState(record) }}
      </template>
      <template #edit="{text,record}">
        <a-button
          v-if="
            record.orderType == 0 &&
              record.aotu == 1 &&
              record.state === 'in_handle'
          "
          size="small"
          @click="finish(record)"
        >
          审核
        </a-button>
        <div style="margin-top:10px"></div>
        <a-button
          v-if="
            record.orderType == 0 &&
              record.aotu == 1 &&
              record.state === 'in_handle'
          "
          size="small"
          @click="cancel(record)"
        >
          作废
        </a-button>
      </template>
    </a-table>
    <!-- modal -->
    <a-modal v-model:visible="visible" @ok="add">
      <template #title>
        <span>增加积分兑换订单</span>
      </template>
      <a-form
        layout="inline"
        labelAlign="left"
        :labelCol="labelCol"
        :rules="rules"
        ref="formRef"
        :model="modal"
      >
        <a-row>
          <a-col :span="24">
            <a-form-item label="积分平台订单号" name="supplierOrderId">
              <a-input
                style="width:250px"
                v-model:value="modal.supplierOrderId"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="积分平台会员ID" name="memberId">
              <a-input
                style="width:250px"
                v-model:value="modal.memberId"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="积分名称" name="carrier">
              <a-select v-model:value="modal.carrier" style="width:250px">
                <a-select-option
                  v-for="(item, index) in scoreNameList"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="中文姓" name="surnameCn">
              <a-input
                style="width:250px"
                v-model:value="modal.surnameCn"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="中文名" name="givenNameCn">
              <a-input
                style="width:250px"
                v-model:value="modal.givenNameCn"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="英文姓" name="surnameEn">
              <a-input
                style="width:250px"
                v-model:value="modal.surnameEn"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="英文名" name="givenNameEn">
              <a-input
                style="width:250px"
                v-model:value="modal.givenNameEn"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="证件类型">
              <a-select style="width:250px" v-model:value="modal.idType">
                <a-select-option
                  v-for="(item, index) in cardList"
                  :key="index"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="证件号">
              <a-input
                style="width:250px"
                v-model:value="modal.idNumber"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="性别">
              <a-radio-group
                v-model:value="modal.gender"
                :options="genderList"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="出生日期">
              <a-input
                style="width:250px"
                v-model:value="modal.birthday"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="移动电话">
              <a-input
                style="width:250px"
                v-model:value="modal.mobile"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="联系邮箱">
              <a-input
                style="width:250px"
                v-model:value="modal.email"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="渠道名称" name="distributorId">
              <a-select v-model:value="modal.distributorId" style="width:250px">
                <a-select-option
                  v-for="(item, index) in channelList"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="渠道订单号" name="distributorOrderId">
              <a-input
                style="width:250px"
                v-model:value="modal.distributorOrderId"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="交易金额">
              <a-input
                style="width:250px"
                v-model:value="modal.payAmount"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="积分数额" name="amount">
              <a-input
                style="width:250px"
                v-model:value="modal.amount"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="渠道会员ID" name="distributorAccount">
              <a-input
                v-model:value="modal.distributorAccount"
                style="width:250px"
              >
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="是否自动兑换" name="aotu">
              <a-select v-model:value="modal.aotu" style="width:250px">
                <a-select-option value="0">是</a-select-option>
                <a-select-option value="1">否</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!-- 导入文件 -->
    <a-modal
      v-model:visible="createVisible"
      title="导入对账单"
      :footer="null"
      :maskClosable="false"
    >
      <a-spin :spinning="createSpinning">
        <a-form layout="inline">
          <a-row
            type="flex"
            justify="space-around"
            align="middle"
            class="creatRow"
          >
            <a-col :span="4">
              <CloudDownloadOutlined />
            </a-col>
            <a-col :span="20">
              <p>填写导入数据信息</p>
              <p>
                请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除
              </p>
              <p @click="templateDownload" style="color: #1bba79">下载模板</p>
            </a-col>
          </a-row>
          <a-row
            type="flex"
            justify="space-around"
            align="middle"
            class="creatRow"
          >
            <a-col :span="4">
              <CloudUploadOutlined />
            </a-col>
            <a-col :span="20">
              <p>上传填好的信息表</p>
              <p>
                文件后缀名必须为xls 或xlsx
                （即Excel格式），文件大小不得大于10M，最多支持导入3000条数据
              </p>
              <a-upload
                :fileList="fileList"
                :remove="handleRemove"
                :beforeUpload="beforeUpload"
              >
                <p class="handle" style="color: #1bba79; font-weight: normal">
                  上传文件
                </p>
              </a-upload>
            </a-col>
          </a-row>
          <a-row
            type="flex"
            justify="space-around"
            align="middle"
            class="tipRow"
          >
            <a-col :span="3">
              <ExclamationCircleOutlined />
            </a-col>
            <a-col :span="21">
              <p>特别提示</p>
              <p>单号不能重复</p>
            </a-col>
          </a-row>

          <a-form-item>
            <a-button type="primary" @click="createCancel"> 取消 </a-button>
          </a-form-item>
          <a-form-item>
            <a-button @click="handleUpload">上传</a-button>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
    <df-pagination :model="pageObj"></df-pagination>
    <!-- 上传成功后的弹出框 -->

    <a-modal
      v-model:visible="uploadDialog"
      :cancel-button-props="{ style: { display: 'none' } }"
      @ok="() => (uploadDialog = false)"
    >
      <div style="font-size:18px">上传成功</div>
      <template slot="footer">
        <a-button
          type="primary"
          @click.stop="
            () => {
              uploadDialog = false;
            }
          "
          >返回</a-button
        >
      </template>
    </a-modal>
  </div>
</template>

<script>
import { reactive, ref, provide, watch } from "vue";
import orderApi from "@axios/order";
import { message, Spin } from "ant-design-vue";
import { exportOut } from "@axios/exportOut";
import vPinyin from "../../utils/pay";
import {
  CloudDownloadOutlined,
  CloudUploadOutlined,
  ExclamationCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons-vue";
export default {
  components: {
    CloudDownloadOutlined,
    CloudUploadOutlined,
    ExclamationCircleOutlined,
    UploadOutlined,
    Spin,
  },
  setup() {
    let uploadDialog = ref(false);
    let loading = ref(false);
    const resetForm = ref();
    let form = reactive({
      //积分平台订单号
      supplierOrderId: "",
      // distributorOrderId: "",
      //积分名称
      carrier: "",
      //积分平台会员Id
      memberId: "",
      //兑换时间
      date: [],
      //订单号
      orderId: "",
      //渠道名称
      distributorId: "",
      //渠道会员ID
      distributorAccount: "",
      //订单状态
      state: "",
    });
    //genderList
    let genderList = ref([
      {
        value: "M",
        label: "男",
      },
      {
        value: "F",
        label: "女",
      },
    ]);
    //list
    let list = ref([]);
    //弹出框form
    const formRef = ref();
    let modal = reactive({
      //积分平台订单号
      supplierOrderId: "",
      //积分平台会员ID
      memberId: "",
      //积分名称
      carrier: "",
      //中文姓
      surnameCn: "",
      //中文名
      givenNameCn: "",
      //英文姓
      surnameEn: "",
      //英文名
      givenNameEn: "",
      //证件类型
      idType: "",
      //证件号
      idNumber: "",
      //生日
      birthday: "",
      //电话
      mobile: "",
      //邮箱
      email: "",
      //渠道名称
      distributorId: "",
      //交易金额
      payAmount: "",
      //积分数额
      amount: "",
      //渠道会员ID
      distributorAccount: "",
      //性别
      gender: "",
      aotu: 1,
    });
    let orderTypeList = reactive([
      {
        value: "",
        name: "全部",
      },
      {
        value: "wait_pay",
        name: "待支付",
      },
      {
        value: "pay_fail",
        name: "支付失败",
      },
      {
        value: "wait_handle",
        name: "支付成功待处理",
      },
      {
        value: "in_handle",
        name: "支付成功处理中",
      },
      {
        value: "finished",
        name: "支付成功处理成功",
      },
      {
        value: "failed",
        name: "支付成功处理失败",
      },
      {
        value: "cancelled",
        name: "取消",
      },
    ]);
    let channelNameList = reactive([
      {
        value: "",
        name: "全部",
      },
      {
        value: 1041,
        name: "关爱通",
      },
      {
        value: 1042,
        name: "里程惠",
      },
      {
        value: 1044,
        name: "东美",
      },
    ]);
    //积分名称
    let scoreNameList = reactive([
      {
        value: "",
        name: "全部",
      },
      {
        value: "MU",
        name: "东航",
      },
      {
        value: "CA",
        name: "国航",
      },
      {
        value: "CZ",
        name: "南航",
      },
    ]);
    //身份证类型
    let cardList = [
      {
        value: 0,
        name: "身份证",
      },
      {
        value: 1,
        name: "护照",
      },
    ];
    let channelList = reactive([
      {
        value: "1041",
        name: "关爱通",
      },
      {
        value: "1042",
        name: "里程惠",
      },
      {
        value: "1044",
        name: "东美",
      },
    ]);

    //method  data
    let visible = ref(false);
    //查询
    let query = () => {
      loading.value = true;
      let params = {
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
      };
      //积分平台订单号
      form.supplierOrderId
        ? (params.supplierOrderId = form.supplierOrderId)
        : "";

      //积分名称
      form.carrier ? (params.carrier = form.carrier) : "";
      //积分平台会员ID
      form.memberId ? (params.memberId = form.memberId) : "";
      //兑换时间
      if (form.date) {
        params.checkBegin = form.date[0];
        params.checkEnd = form.date[1];
      }
      //订单号
      form.orderId ? (params.orderId = form.orderId) : "";
      //渠道名称
      form.distributorId ? (params.distributorId = form.distributorId) : "";
      //渠道会员ID
      form.distributorAccount
        ? (params.distributorAccount = form.distributorAccount)
        : "";
      //订单状态
      form.state ? (params.state = form.state + ",") : "";
      orderApi.scoreList(params).then((res) => {
        loading.value = false;
        list.value = res.data;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;
      });
    };

    //增加
    let add = () => {
      formRef.value.validate().then(() => {
        orderApi.addScoreOrder(modal).then((res) => {
          message.success('兑换成功');
          visible.value = false;
          query();
        });
      });
    };
    //导出
    let exports = () => {
      let params = {
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
      };
      //积分平台订单号
      form.supplierOrderId
        ? (params.supplierOrderId = form.supplierOrderId)
        : "";

      //积分名称
      form.carrier ? (params.carrier = form.carrier) : "";
      //积分平台会员ID
      form.memberId ? (params.memberId = form.memberId) : "";
      //兑换时间
      // if (form.date) {
      //   params.checkBegin = form.date[0];
      //   params.checkEnd = form.date[1];
      // }
      //订单号
      form.orderId ? (params.orderId = form.orderId) : "";
      //渠道名称
      form.distributorId ? (params.distributorId = form.distributorId) : "";
      //渠道会员ID
      form.distributorAccount
        ? (params.distributorAccount = form.distributorAccount)
        : "";
      // 订单状态;
      form.state ? (params.state = form.state + ",") : "";
      let fileName = "航司积分明细-";
      exportOut(
        params, // 导出请求参数
        "/app-admin//point/download", // 接口地址
        fileName // 导出文件名字
      );
    };
    //上传文件
    let createVisible = ref(false);
    // loading
    let createSpinning = ref(false);
    const createBill = () => {
      createVisible.value = true;
    };
    let fileList = ref([]);
    const handleRemove = (file) => {
      // 移除文件时，要重新给fileList赋值
      let arr = [];
      for (let i = 0; i < fileList.value.length; i++) {
        if (fileList.value[i].uid !== file.uid) {
          arr.push(fileList.value[i]);
        }
      }
      fileList.value = arr;
      console.log(fileList.value);
    };
    // 上传前校验
    const beforeUpload = (file) => {
      console.log(file);
      // const isXlsOrXlsx = file.type === "xls" || file.type === "xlsx";
      // if (!isXlsOrXlsx) {
      //   message.error("只能上传xls 或xlsx （即Excel格式）!");
      // }
      // const isLt10M = file.size / 1024 / 1024 < 10;
      // if (!isLt10M) {
      //   message.error("文件大小不得大于10M!");
      // }
      // return isXlsOrXlsx && isLt10M;
      fileList.value = [...fileList.value, file];
      return false;
    };
    // 上传
    const handleUpload = () => {
      if (fileList.value == "") return;
      createSpinning.value = true;
      console.log(fileList.value);
      const formData = new FormData();
      fileList.value.forEach((file) => {
        formData.append("file", file);
        console.log(file);
      });
      orderApi.createBill(formData).then((res) => {
        console.log(res, "上传");
        fileList.value = [];
        // message.success("上传成功");
        setTimeout(() => {
          createSpinning.value = false;
          uploadDialog.value = true;
          createVisible.value = false;
        }, 3000);
        query();
      });
    };
    // 下载模板
    const templateDownload = () => {
      let params = {};
      let fileName = "模板";
      exportOut(
        params, // 导出请求参数
        "/app-admin/point/download/template", // 接口地址
        fileName // 导出文件名字
      );
    };
    //作废
    let cancel = (record) => {
      let params = {
        id: record.id,
        orderId: record.orderId,
        state: "cancelled",
      };
      orderApi.updateOrderType(params).then((res) => {
        if (res.id) {
          message.success("更新状态成功");
          query();
        }
      });
    };
    //审核
    let finish = (record) => {
      let params = {
        id: record.id,
        orderId: record.orderId,
        state: "finished",
      };
      orderApi.updateOrderType(params).then((res) => {
        if (res.id) {
          message.success("更新状态成功");
          query();
        }
      });
    };
    let rules = {
      aotu: [
        {
          required: true,
          message: "请选择是否自动兑换",
          trigger: "blur",
        },
      ],
      surnameCn: [
        {
          required: true,
          message: "请输入中文姓",
          trigger: "blur",
        },
      ],
      givenNameCn: [
        {
          required: true,
          message: "请输入中文名",
          trigger: "blur",
        },
      ],
      surnameEn: [
        {
          required: true,
          message: "请输入英文姓",
          trigger: "blur",
        },
      ],
      givenNameEn: [
        {
          required: true,
          message: "请输入英文名",
          trigger: "blur",
        },
      ],
      distributorId: [
        {
          required: true,
          message: "请选择渠道名称",
          trigger: "blur",
        },
      ],
      distributorOrderId: [
        {
          required: true,
          message: "请填写渠道订单号",
          trigger: "blur",
        },
      ],
      supplierOrderId: [
        {
          required: true,
          message: "请填写积分平台订单号",
          trigger: "blur",
        },
      ],
      carrier: [
        {
          required: true,
          message: "请选择积分名称",
          trigger: "blur",
        },
      ],

      payAmount: [
        {
          required: true,
          message: "请填写交易金额",
          trigger: "blur",
        },
      ],
      amount: [
        {
          required: true,
          message: "请填写积分数额",
          trigger: "blur",
        },
      ],
      memberId: [
        {
          required: true,
          message: "请填写积分平台会员ID",
          trigger: "blur",
        },
      ],
    };
    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });
    const pageChange = (page) => {
      pageObj.value.page = page;
      query();
    };
    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      query();
    };

    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);
    query();
    //表单重置
    let reset = () => {
      resetForm.value.resetFields();
      query();
    };
    //判断状态
    let compareState = (record) => {
      switch (record.state) {
        case "cancelled":
          return "取消";
        case "wait_pay":
          return "待支付";
        case "pay_fail":
          return "支付失败";
        case "wait_handle":
          return "支付成功待处理";
        case "in_handle":
          return "支付成功处理中";
        case "finished":
          return "支付成功处理成功";
        case "failed":
          return "支付成功处理失败";
      }
    };
    //打开弹出框
    let openModal = () => {
      visible.value = true;
      Object.keys(modal).forEach((item) => {
        modal[item] = "";
      });
    };
    //中文关联英文名
    //中文转英文
    watch(
      () => [modal.surnameCn, modal.givenNameCn],
      () => {
        modal.surnameEn = vPinyin.chineseToPinYin(modal.surnameCn);
        modal.givenNameEn = vPinyin.chineseToPinYin(modal.givenNameCn);
      },
      {
        immediate: true,
        deep: true,
      }
    );
    return {
      uploadDialog,
      beforeUpload,
      templateDownload,
      createSpinning,
      handleUpload,
      fileList,
      handleRemove,
      createVisible,
      createBill,
      openModal,
      loading,
      genderList,
      finish,
      cancel,
      exports,
      resetForm,
      reset,
      compareState,
      onShowSizeChange,
      pageChange,
      pageObj,
      add,
      formRef,
      modal,
      rules,
      query,
      cardList,
      //method data
      visible,
      //data
      channelList,
      form,
      orderTypeList,
      channelNameList,
      scoreNameList,
      list,
      columns: [
        {
          title: "积分平台订单号",
          dataIndex: "supplierOrderId",
          width: 150,
          align: "center",
        },
        {
          title: "积分名称",
          dataIndex: "carrier",
          width: 150,
          align: "center",
          slots: {
            customRender: "carrier",
          },
        },
        {
          title: "积分平台会员ID",
          dataIndex: "memberId",
          width: 150,
          align: "center",
        },
        {
          title: "订单号",
          dataIndex: "orderId",
          key: "orderId",
          width: 200,
          align: "center",
        },
        {
          title: "渠道名称",
          dataIndex: "distributorName",
          key: "distributorName",
          width: 150,
          align: "center",
        },
        {
          title: "渠道会员ID",
          dataIndex: "distributorAccount",
          key: "distributorAccount",
          width: 150,
          align: "center",
        },
        {
          title: "交易时间",
          dataIndex: "submitTime",
          key: "submitTime",
          width: 150,
          align: "center",
        },
        {
          title: "交易金额",
          key: "payAmount",
          width: 150,
          align: "center",
          slots: { customRender: "payAmount" },
        },
        {
          title: "积分数额",
          dataIndex: "amount",
          key: "amount",
          width: 150,
          align: "center",
        },
        {
          title: "订单状态",
          width: 150,
          align: "center",
          slots: {
            customRender: "orderState",
          },
        },
        {
          title: "备注",
          dataIndex: "remark",
          width: 150,
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 150,
          slots: {
            customRender: "edit",
          },
        },
      ],
      labelCol: {
        style: {
          width: "120px",
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
/deep/ label {
  font-weight: normal;
}
.ant-table-wrapper {
  overflow: auto;
}
/deep/ .ant-modal-title {
  text-align: center !important;
  color: red !important;
}
.ant-col {
  padding: 0 10px 10px 10px;
}
.mr {
  margin-right: 10px;
}
.creatRow {
  border: 1px solid #f5f5f5;
  margin-bottom: 15px;
  .ant-col-4 {
    text-align: center;
    font-size: 30px;
  }
  p {
    line-height: 1.5;
    margin: 10px 0;
    &:nth-of-type(1) {
      font-weight: bold;
    }
    &:nth-of-type(2) {
      font-size: 12px;
      color: #666;
    }
    &:nth-of-type(3) {
      color: #40a9ff;
      cursor: pointer;
    }
  }
  .handle {
    line-height: 1.5;
    margin-top: 0;
    margin-bottom: 10px;
    color: #40a9ff;
    cursor: pointer;
  }
}
.ant-modal-footer {
  border-top: none !important;
  background: red !important;
}
.example {
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
</style>
